module.exports = "/images/uz.svg?258e0ffc8ab924066d9358af51526a5f";